// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.102.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-device-preview {
  margin: 8px 0 28px;
}

.notification-device-preview__title {
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 600;
}

.notification-device-preview__hint {
  margin: 0 0 16px;
  color: #555;
  font-size: 13px;
  max-width: 820px;
  line-height: 1.45;
}

.notification-device-preview__controls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px 20px;
  margin-bottom: 16px;
}

.notification-device-preview__modes {
  display: inline-flex;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
}

.notification-device-preview__mode {
  border: 0;
  background: #fff;
  padding: 8px 12px;
  font-size: 13px;
  cursor: pointer;
  color: #444;
}

.notification-device-preview__mode + .notification-device-preview__mode {
  border-left: 1px solid #ddd;
}

.notification-device-preview__mode.is-active {
  background: #284f43;
  color: #fff;
}

.notification-device-preview__scale {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  color: #555;
  min-width: 220px;
}

.notification-device-preview__scale-unit {
  font-weight: 400;
  color: #777;
}

.notification-device-preview__scale input {
  width: 100%;
}

.notification-device-preview__devices {
  display: flex;
  flex-wrap: wrap;
  gap: 24px 20px;
  align-items: flex-start;
}

.notification-device-preview__device {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.notification-device-preview__label {
  font-size: 13px;
  font-weight: 600;
  color: #333;
  letter-spacing: 0.02em;
}

.notification-device-preview__spec {
  font-size: 11px;
  color: #777;
  margin-bottom: 4px;
}

.notification-device-preview__meta {
  position: relative;
  display: flex;
  gap: 8px;
  align-items: center;
  font-size: 11px;
  color: #666;
  margin-top: 4px;
}

.notification-device-preview__clip.is-clipped {
  color: #a15c00;
  font-weight: 600;
}

.notif-lock-fill {
  flex: 1 1;
  width: 100%;
  height: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.notif-lock {
  flex: 1 1;
  width: 100%;
  height: 100%;
  min-width: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: calc(28 * var(--pt)) calc(16 * var(--pt)) calc(14 * var(--pt));
  background: radial-gradient(circle at 20% 20%, #3a5443 0%, transparent 42%), linear-gradient(180deg, #1a1a1c 0%, #0b0b0d 100%);
  color: #fff;
  overflow: hidden;
}

.notif-lock--lock .notif-lock__card,
.notif-lock--expanded .notif-lock__card {
  margin-top: auto;
}

.notif-lock__banner-spacer {
  height: calc(14 * var(--pt));
}

.notif-lock__time {
  text-align: center;
  font-size: calc(64 * var(--pt));
  font-weight: 600;
  line-height: 1;
  letter-spacing: calc(-2 * var(--pt));
  margin-top: calc(12 * var(--pt));
}

.notif-lock__time--android {
  font-size: calc(72 * var(--pt));
  font-weight: 300;
  margin-top: calc(20 * var(--pt));
}

.notif-lock__date {
  text-align: center;
  font-size: calc(15 * var(--pt));
  opacity: 0.85;
  margin: calc(6 * var(--pt)) 0 calc(16 * var(--pt));
}

.notif-lock__android-status {
  font-size: calc(12 * var(--pt));
  font-weight: 600;
  padding: 0 calc(4 * var(--pt));
}

.notif-lock__card {
  background: rgba(255, 255, 255, 0.88);
  color: #111;
  padding: calc(10 * var(--pt)) calc(12 * var(--pt)) calc(12 * var(--pt));
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.18);
}

.notif-lock__card--ios {
  border-radius: calc(20 * var(--pt));
}

.notif-lock__card--android {
  border-radius: calc(16 * var(--pt));
  background: #2c2c2e;
  color: #f2f2f2;
}

.notif-lock__app-row {
  display: flex;
  align-items: center;
  gap: calc(8 * var(--pt));
  margin-bottom: calc(4 * var(--pt));
}

.notif-lock__icon {
  width: calc(20 * var(--pt));
  height: calc(20 * var(--pt));
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: calc(11 * var(--pt));
  font-weight: 700;
  flex-shrink: 0;
}

.notif-lock__icon--ios {
  background: #284f43;
  color: #fff;
  border-radius: calc(5 * var(--pt));
}

.notif-lock__icon--android {
  background: #284f43;
  color: #fff;
  border-radius: calc(5 * var(--pt));
}

.notif-lock__app {
  flex: 1 1;
  font-size: calc(13 * var(--pt));
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.notif-lock__card--android .notif-lock__app {
  color: #cfcfcf;
  text-transform: none;
  letter-spacing: 0;
  font-size: calc(13 * var(--pt));
}

.notif-lock__now {
  font-size: calc(12 * var(--pt));
  color: #888;
  flex-shrink: 0;
}

.notif-lock__body {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: calc(15 * var(--pt));
  line-height: 1.28;
  white-space: pre-wrap;
  word-break: break-word;
}

.notif-lock__android-copy {
  min-width: 0;
  flex: 1 1;
}

.notif-lock__android-copy .notif-lock__body {
  margin-top: calc(2 * var(--pt));
  color: #e8e8e8;
}`, "",{"version":3,"sources":["webpack://./src/components/admin/NotificationDevicePreview.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;AACF;;AAEA;EACE,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,mBAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,WAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;AACF;;AAEA;EACE,eAAA;EACA,WAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,SAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,SAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,uEAAA;EACA,8HACE;EAEF,WAAA;EACA,gBAAA;AADF;;AAIA;;EAEE,gBAAA;AADF;;AAIA;EACE,4BAAA;AADF;;AAIA;EACE,kBAAA;EACA,+BAAA;EACA,gBAAA;EACA,cAAA;EACA,oCAAA;EACA,gCAAA;AADF;;AAIA;EACE,+BAAA;EACA,gBAAA;EACA,gCAAA;AADF;;AAIA;EACE,kBAAA;EACA,+BAAA;EACA,aAAA;EACA,kDAAA;AADF;;AAIA;EACE,+BAAA;EACA,gBAAA;EACA,8BAAA;AADF;;AAIA;EACE,qCAAA;EACA,WAAA;EACA,uEAAA;EACA,0CAAA;AADF;;AAIA;EACE,mCAAA;AADF;;AAIA;EACE,mCAAA;EACA,mBAAA;EACA,cAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,kCAAA;AADF;;AAIA;EACE,2BAAA;EACA,4BAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,gBAAA;EACA,cAAA;AADF;;AAIA;EACE,mBAAA;EACA,WAAA;EACA,kCAAA;AADF;;AAIA;EACE,mBAAA;EACA,WAAA;EACA,kCAAA;AADF;;AAIA;EACE,SAAA;EACA,+BAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AADF;;AAIA;EACE,cAAA;EACA,oBAAA;EACA,iBAAA;EACA,+BAAA;AADF;;AAIA;EACE,+BAAA;EACA,WAAA;EACA,cAAA;AADF;;AAIA;EACE,oBAAA;EACA,4BAAA;EACA,gBAAA;EACA,+BAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;AADF;;AAIA;EACE,YAAA;EACA,SAAA;AADF;;AAIA;EACE,+BAAA;EACA,cAAA;AADF","sourcesContent":[".notification-device-preview {\n  margin: 8px 0 28px;\n}\n\n.notification-device-preview__title {\n  margin: 0 0 4px;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.notification-device-preview__hint {\n  margin: 0 0 16px;\n  color: #555;\n  font-size: 13px;\n  max-width: 820px;\n  line-height: 1.45;\n}\n\n.notification-device-preview__controls {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 16px 20px;\n  margin-bottom: 16px;\n}\n\n.notification-device-preview__modes {\n  display: inline-flex;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.notification-device-preview__mode {\n  border: 0;\n  background: #fff;\n  padding: 8px 12px;\n  font-size: 13px;\n  cursor: pointer;\n  color: #444;\n}\n\n.notification-device-preview__mode + .notification-device-preview__mode {\n  border-left: 1px solid #ddd;\n}\n\n.notification-device-preview__mode.is-active {\n  background: #284f43;\n  color: #fff;\n}\n\n.notification-device-preview__scale {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #555;\n  min-width: 220px;\n}\n\n.notification-device-preview__scale-unit {\n  font-weight: 400;\n  color: #777;\n}\n\n.notification-device-preview__scale input {\n  width: 100%;\n}\n\n.notification-device-preview__devices {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 24px 20px;\n  align-items: flex-start;\n}\n\n.notification-device-preview__device {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n}\n\n.notification-device-preview__label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #333;\n  letter-spacing: 0.02em;\n}\n\n.notification-device-preview__spec {\n  font-size: 11px;\n  color: #777;\n  margin-bottom: 4px;\n}\n\n.notification-device-preview__meta {\n  position: relative;\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  font-size: 11px;\n  color: #666;\n  margin-top: 4px;\n}\n\n.notification-device-preview__clip.is-clipped {\n  color: #a15c00;\n  font-weight: 600;\n}\n\n.notif-lock-fill {\n  flex: 1;\n  width: 100%;\n  height: 100%;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.notif-lock {\n  flex: 1;\n  width: 100%;\n  height: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  padding: calc(28 * var(--pt)) calc(16 * var(--pt)) calc(14 * var(--pt));\n  background:\n    radial-gradient(circle at 20% 20%, #3a5443 0%, transparent 42%),\n    linear-gradient(180deg, #1a1a1c 0%, #0b0b0d 100%);\n  color: #fff;\n  overflow: hidden;\n}\n\n.notif-lock--lock .notif-lock__card,\n.notif-lock--expanded .notif-lock__card {\n  margin-top: auto;\n}\n\n.notif-lock__banner-spacer {\n  height: calc(14 * var(--pt));\n}\n\n.notif-lock__time {\n  text-align: center;\n  font-size: calc(64 * var(--pt));\n  font-weight: 600;\n  line-height: 1;\n  letter-spacing: calc(-2 * var(--pt));\n  margin-top: calc(12 * var(--pt));\n}\n\n.notif-lock__time--android {\n  font-size: calc(72 * var(--pt));\n  font-weight: 300;\n  margin-top: calc(20 * var(--pt));\n}\n\n.notif-lock__date {\n  text-align: center;\n  font-size: calc(15 * var(--pt));\n  opacity: 0.85;\n  margin: calc(6 * var(--pt)) 0 calc(16 * var(--pt));\n}\n\n.notif-lock__android-status {\n  font-size: calc(12 * var(--pt));\n  font-weight: 600;\n  padding: 0 calc(4 * var(--pt));\n}\n\n.notif-lock__card {\n  background: rgba(255, 255, 255, 0.88);\n  color: #111;\n  padding: calc(10 * var(--pt)) calc(12 * var(--pt)) calc(12 * var(--pt));\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.18);\n}\n\n.notif-lock__card--ios {\n  border-radius: calc(20 * var(--pt));\n}\n\n.notif-lock__card--android {\n  border-radius: calc(16 * var(--pt));\n  background: #2c2c2e;\n  color: #f2f2f2;\n}\n\n.notif-lock__app-row {\n  display: flex;\n  align-items: center;\n  gap: calc(8 * var(--pt));\n  margin-bottom: calc(4 * var(--pt));\n}\n\n.notif-lock__icon {\n  width: calc(20 * var(--pt));\n  height: calc(20 * var(--pt));\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(11 * var(--pt));\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.notif-lock__icon--ios {\n  background: #284f43;\n  color: #fff;\n  border-radius: calc(5 * var(--pt));\n}\n\n.notif-lock__icon--android {\n  background: #284f43;\n  color: #fff;\n  border-radius: calc(5 * var(--pt));\n}\n\n.notif-lock__app {\n  flex: 1;\n  font-size: calc(13 * var(--pt));\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #666;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.notif-lock__card--android .notif-lock__app {\n  color: #cfcfcf;\n  text-transform: none;\n  letter-spacing: 0;\n  font-size: calc(13 * var(--pt));\n}\n\n.notif-lock__now {\n  font-size: calc(12 * var(--pt));\n  color: #888;\n  flex-shrink: 0;\n}\n\n.notif-lock__body {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  font-size: calc(15 * var(--pt));\n  line-height: 1.28;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.notif-lock__android-copy {\n  min-width: 0;\n  flex: 1;\n}\n\n.notif-lock__android-copy .notif-lock__body {\n  margin-top: calc(2 * var(--pt));\n  color: #e8e8e8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
